import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { OrderResponseItem } from '../../data/models'
import i18n from '../../utils/i18n'
import { StatusTag } from './StatusTag'

export const StatusFilterTemplate = (options: any) => {
  if (!options) return null

  const status: OrderResponseItem['ConfirmationCode'][] = [
    'NOT_SET',
    'MODIFIED',
    'ACCEPTED',
    'REJECTED',
  ]

  const valueTemplate = (option: any, props: any) => {
    if (option) {
      return <StatusTag status={option} />
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => {
    return <StatusTag status={option} />
  }

  return (
    <Dropdown
      value={options.value}
      options={status}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.searchStatus')}
    />
  )
}
